import React, { useState, useEffect } from 'react';

import { TextField, Tooltip } from '@mui/material';

import { IQuestionnaireFormWidgetProps } from 'src/features/questionnaire/domain/types';

const DecimalFieldWidget: React.FC<IQuestionnaireFormWidgetProps> = ({
	question,
	onValueChange,
	isDisabled,
	error,
	helperText = 'This field is invalid',
}) => {
	const value = question.submitted_data?.value_decimal ?? '';

	const [decimalValue, setDecimalValue] = useState(value);

	const handleDecimalChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const value = parseFloat(e.target.value);
		const updatedValue = isNaN(value) ? '' : value;

		setDecimalValue(updatedValue);
		onValueChange(question, updatedValue, 'value_decimal');
	};

	const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
		(e.target as HTMLInputElement).blur();
	};

	useEffect(() => {
		if (value === decimalValue) return;

		setDecimalValue(value);
		onValueChange(question, value, 'value_decimal');
	}, [value]);

	const getToolTipTitle = () => {
		return (
			<span style={{ whiteSpace: 'pre-line' }}>
				Q: {question.text}
				{decimalValue ? `\n\nAns: ${decimalValue}` : ''}
			</span>
		);
	};

	return (
		<Tooltip title={getToolTipTitle()} arrow placement='left-start'>
			<TextField
				fullWidth
				label={question.text}
				required={question.is_required}
				type='number'
				value={decimalValue}
				disabled={isDisabled}
				InputProps={{
					inputProps: {
						step: '0.1',
						min: 0,
						onWheel: handleWheel,
					},
				}}
				onChange={handleDecimalChange}
				error={error}
				helperText={error ? helperText : ''}
				sx={{
					'& input': {
						textOverflow: 'ellipsis',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
					},
				}}
			/>
		</Tooltip>
	);
};

export default DecimalFieldWidget;
